// import { extend, validateAll } from "indicative/validator";
import {
  Field,
  FieldProps,
  Form,
  FormikProvider,
  useFormik
} from 'formik';
import { isNil } from 'lodash';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import OtpInput from 'react18-input-otp';
import * as Yup from 'yup';
import { components } from '../components';
import { showSuccessToast } from '../components/Toast';
import constants from '../helpers/constants';
import utils from '../helpers/utils';
import { hooks } from '../hooks';
import { Routes, TabScreens } from '../routes';
import '../scss/component/_otp.scss';
import apiService from '../service/ApiService';
import { RootState } from '../store';
import { setUserPoints } from '../store/slices/appSlice';
import { setLogin } from '../store/slices/authSlice';
import { setSignupBonus } from '../store/slices/cartSlice';
import { setScreen } from '../store/slices/tabSlice';

const validationSchema = Yup.object().shape({
  otp: Yup.string()
    .required('Please enter OTP.')
    .length(4, 'Please enter 4 digits OTP.'),
});

export const OtpScreen: React.FC = ({
  navigation,
  route,
}: {
  [key: string]: any;
}) => {
  //   const theme = useTheme();
  const dispatch = hooks.useDispatch();
  const navigate = hooks.useNavigate();
  //   const { phoneNumber, isUserVerification } = route.params;
  const currentScreen = useSelector(
    (state: RootState) => state.screenReducer.currentScreen
  );
  const location = useLocation();
  const { phoneNumber, isUserVerification, isLoggedIn } = location.state || {};
  const [opacity, setOpacity] = useState<number>(1);

  const [isResendVisible, setIsResendVisible] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isScreenLoading, setIsScreenLoading] = useState(false);
  const [seconds, setSeconds] = useState(constants.otpTimeOut);
  const [deviceId, setDeviceId] = useState(null);
  const [state, setState] = useState({
    otp: null,
    errors: {},
  });

  useEffect(() => {
    async function bootstrapAsync() {
      try {
        // setIsScreenLoading(true);
        const deviceId = utils.getItemFromStorage(
          constants.secureStore.device.id
        );
        if (isNil(deviceId)) {
          //   addNewDevice();
        } else {
          // device exists in store
          // CjUtils.consoleLog(`Device: ${deviceId} found in mobile cache`);
          //   setDeviceId(deviceId);
          setIsScreenLoading(false);
        }
      } catch (error) {
        // CjUtils.consoleError(error);
        setIsScreenLoading(false);
      }
    }
    bootstrapAsync();
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      if (seconds > 0) {
        setSeconds(seconds - 1);
      } else {
        setIsResendVisible(true);
      }
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  }, [seconds]);

  const resendOtp = async () => {
    const apiData = {
      phone: phoneNumber,
    };
    let data, error;
    if (isUserVerification) {
      ({ data, error } = await apiService.updateUserPhoneAsync(apiData));
    } else {
      ({ data } = await apiService.resendOtpApiAsync(apiData));
    }

    if (data) {
      // CjUtils.showToastMessage('OTP sent successfully.', theme);
      setSeconds(constants.otpTimeOut);
      setIsResendVisible(false);
    } else if (error) {
      formik.setErrors({ otp: error });
    }
    setIsSubmitting(false);
  };

  async function onOtpVerify(values: any) {
    setIsSubmitting(true);
    setIsScreenLoading(true);
    const deviceToken = utils.getItemFromStorage(
      constants.secureStore.device.fcmToken
    );
    const apiData = {
      phone: phoneNumber,
      otp: values.otp,
      deviceId: deviceId,
      deviceToken: deviceToken,
    };
    const { data, error } = await apiService.verifyOtpApiAsync(apiData);
    if (data) {
      const user = data.user;
      const token = data.session;
      const refreshToken = data.refresh;
      utils.setItemToStorage(constants.secureStore.loggedIn.userToken, token);
      utils.setItemToStorage(
        constants.secureStore.loggedIn.refreshToken,
        refreshToken
      );

      dispatch(
        setLogin({ user: user, token: token, refreshToken: refreshToken })
      );
      dispatch(setUserPoints({ userPoint: isLoggedIn ? data.user?.userBalance?.balance : data.user?.userBalance }));
      dispatch(setSignupBonus(data.promotion));
      showSuccessToast("OTP verified successfully.");
      dispatch(setScreen(TabScreens.Home));
      navigate(Routes.TabNavigator);
    } else if (error) {
      formik.setErrors({ otp: error.otp });
    }
    setIsSubmitting(false);
    setIsScreenLoading(false);
  }

  const formik = useFormik({
    initialValues: {
      otp: '',
    },
    validationSchema,
    onSubmit: async (values, { setSubmitting, setErrors }) => {
      setSubmitting(true);
      setIsSubmitting(true);
      if (isUserVerification) {
        // onDataChangeVerify(values);
      } else {
        onOtpVerify(values);
      }

      setSubmitting(false);

      setIsSubmitting(false);
      // formik.resetForm();
    },
  });

  const renderHeader = (): JSX.Element => {
    return <components.Header showGoBack={true} logo={true} />;
  };

  const renderView = (): JSX.Element => {
    return (
      <main className='scrollable container' style={{ paddingTop: 20 }}>
        <FormikProvider value={formik}>
          <Form autoComplete='off' noValidate onSubmit={formik.handleSubmit}>
            <section
              style={{
                backgroundColor: 'var(--white-color)',
                paddingLeft: 20,
                paddingRight: 20,
                height: '90vh',
                paddingTop: '15%',
                borderRadius: 10,
              }}
            >
              <div className='form-row'>
                <p className='t18'>
                  We have sent a verification code to{' '}
                </p>
                <b className='t18' style={{ fontWeight: 800 }}>{phoneNumber}</b>
              </div>

              <div className='form-row otp-container'>
                <Field name='otp'>
                  {({ field }: FieldProps) => (
                    <OtpInput
                      value={field.value}
                      inputProps={{ inputMode: 'numeric' }}
                      onChange={(otp: any) => formik.setFieldValue('otp', otp)}
                      numInputs={4}
                      containerStyle={{ justifyContent: 'space-between' }}
                      isInputNum={true}
                      inputStyle={{
                        width: '60%',
                        height: '90%',
                        margin: '8px',
                        padding: '10px',
                        border: '1px solid',
                        fontSize: '18px',
                        borderRadius: 4,
                      }}
                      focusStyle={{
                        outline: 'none',
                        border: '1px solid',
                      }}
                    />
                  )}
                </Field>
              </div>

              {formik.touched.otp && formik.errors.otp && (
                <div className='form-row'>
                  <span className='t14' id='otp-error' style={{ color: 'red' }}>
                    {formik.errors.otp}
                  </span>
                </div>
              )}
              {isResendVisible ? (
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignSelf: 'center',
                    justifyContent: 'center',
                  }}
                >
                  <p className='t14'>
                    Didn’t get the OTP ?{' '}
                  </p>
                  <button
                    type='button'
                    style={{
                      background: 'none',
                      color: 'var(--main-turquoise)',
                      border: 'none',
                      padding: 0,
                      fontWeight: 800,
                      cursor: 'pointer',
                      transition: 'color 0.3s ease',
                      marginLeft: 4,
                    }}
                    className='t14'
                    onClick={resendOtp}
                  >
                    Resend OTP
                  </button>
                </div>
              ) : (
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignSelf: 'center',
                    justifyContent: 'center',
                  }}
                >
                  <p className='t16' style={{ color: 'red' }}>
                    Time Remaining:{' '}
                  </p>
                  <p className='t16' style={{ marginLeft: 2 }}>
                    00:{seconds < 10 ? `0${seconds}` : seconds}
                  </p>
                </div>
              )}
              <components.Button
                text='Verify OTP'
                containerStyle={{ marginTop: 20 }}
                disabled={formik.isSubmitting}
              />
            </section>
          </Form>
        </FormikProvider>
      </main>
    );
  };

  return (
    <div id='screen' style={{ opacity }}>
      {renderHeader()}
      {isScreenLoading ? <components.Loader /> : renderView()}
      {/* {renderFooter()} */}
    </div>
  );
};
